import { Component, OnInit } from '@angular/core';

@Component({
    selector: 'app-management-parent',
    templateUrl: './management-parent.component.html',
    styleUrls: ['./management-parent.component.scss'],
    standalone: false
})
export class ManagementParentComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
